import React, { useLayoutEffect, useRef, useContext } from 'react';
import PropTypes from 'prop-types';

import { InteractiveComponentContext } from '../../context';
import './InteractiveComponent.css';

const InteractiveComponent = props => {
  const ref = useRef(null);
  const [, setContext] = useContext(InteractiveComponentContext);

  useLayoutEffect(() => {
    setContext({
      ref,
      style: props.styleProps,
      id: props.id
    });
  }, [ref && ref.current]);

  return <div className="InteractiveComponent__content" ref={ref} />;
};

InteractiveComponent.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  styleProps: PropTypes.object.isRequired
};

export default InteractiveComponent;
